import styled from "styled-components";
import { LesserThan } from "./LesserThan";

export const GreaterThan = styled(LesserThan)`
    transform: rotate(-180deg);
`;

export default GreaterThan;
